import { apiBaseUrls } from '@saucelabs/sl-util-config';

export const FORM_NAME = 'migrationWizardForm';
export const API_CSV_URL = `${apiBaseUrls.encore}/api/users-csv/`;
export const LOADING_MODAL_NAME = 'migrationWizardLoadingModal';
export const EDIT_TEAM_CONCURRENCY_MODAL_NAME = 'migrationWizardEditTeamConcurrencyModal';
// based on k8s statuses:
export const TRANSFER_COMPLETE_STATUS = 'Complete';
export const TRANSFER_FAILED_STATUS = 'Failed';

export const MULTIPLE_TEAMS_EXPERIMENT = 'web-ui-xtm-subscribed-with-multiple-teams';
